<template>
  <div class="container">
    <h1>About</h1>

    <p>
      The overview is based on the <a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element" target="_blank" rel="noreferrer">MDN HTML element reference</a>
      and their <a href="https://github.com/mdn/browser-compat-data" target="_blank" rel="noreferrer">mdn-browser-compat-data</a> Github repo.
    </p>

    <p>
      The page itself is made with <a href="https://vuejs.org" target="_blank" rel="noreferrer">Vue.js</a>,
      the API where the frontend gathers it's information with <a href="https://expressjs.com" target="_blank" rel="noreferrer">Express.js</a>.
      You can take a look at the source code on <a href="https://github.com/GurkenHans/html-element-overview" target="_blank" rel="noreferrer">Github</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'about',
}
</script>

<style scoped>

</style>